// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bigger[data-v-902043e2]{font-size:130%}.legend[data-v-902043e2]{display:flex;max-width:400px}.gradient[data-v-902043e2]{background:linear-gradient(90deg,rgba(225,245,254,.7),rgba(1,87,155,.7));height:5px;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
